module.exports = __webpack_public_path__ + "img/cc-mbs-square-gray.32321a22.png";